import { type FunctionComponent, type PropsWithChildren } from 'react';

import Card from '../Cards/Card';

const Panel: FunctionComponent<PropsWithChildren> = ({ children }) => {
  return <Card>{children}</Card>;
};

export default Panel;
